module.exports = __webpack_public_path__ + "img/logo.58f37502.png";